<ng-container #widget></ng-container>


